import { createContext, useContext } from 'react'
import { useSounds } from '../hooks/useSounds'

const SoundContext = createContext(null)

/**
 * Sound Provider - Wraps app to provide sound playback throughout
 */
export function SoundProvider({ children }) {
  const sounds = useSounds()

  return (
    <SoundContext.Provider value={sounds}>
      {children}
    </SoundContext.Provider>
  )
}

/**
 * Hook to use sounds from any component
 */
export function useSoundContext() {
  const context = useContext(SoundContext)
  if (!context) {
    throw new Error('useSoundContext must be used within a SoundProvider')
  }
  return context
}

export default SoundContext
